<template>
  <div class="integration-settings-account-object-tab">
    <AccountObjectPushWorkflow />
    <PartnerFieldMappings />
    <PartnerTagsPushSection />
  </div>
</template>

<script setup lang="ts">
import AccountObjectPushWorkflow from './AccountObjectPushWorkflow.vue';
import PartnerFieldMappings from './PartnerFieldMappings.vue';
import PartnerTagsPushSection from './PartnerTagsPushSection.vue';
</script>
